import ListingLibTitleWithCounts from 'framework-listing-lib/elements/ListingLibTitleWithCounts';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function EmailHeaderSubtitle() {
  return /*#__PURE__*/_jsx(ListingLibTitleWithCounts, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.header.title"
    })
  });
}
export default EmailHeaderSubtitle;